export const AUTH_RESOURCES = {
    ALL: 'all',
    PROTOCOL: 'Protocol',
    AUDIT_LOG: 'AuditLog',
    USER: 'User',
    CLIENT_DEVICE: 'ClientDevice',
    WIZARD: 'Wizard',
    EQUIPMENT: 'Equipment',
    APPROVAL: 'Approval',
    FIRST_APPROVAL: 'FirstApproval',
    SECOND_APPROVAL: 'SecondApproval',
    SYSTEM_UPDATE: 'SystemUpdate',
    LICENSE: 'License',
    BACKUP: 'Backup',
    CREW_LIST: 'CrewList',
    RESPONSIBILITY: 'Responsibility',
    VOYAGE: 'Voyage',
    VESSEL_PARTICULARS: 'VesselParticulars',
    SHIP_NETWORK_SETTINGS: 'ShipNetworkSettings',
    LWE_NETWORK_SETTINGS: 'LweNetworkSettings',
    AIS_SETTINGS: 'AisSettings',
    AUTOMATED_RECORDING_SETTINGS: 'AutomatedRecordingSettings',
    SYSTEM_TIME_SETTINGS: 'SystemTimeSettings',
    SELF_CHECK: 'SelfCheck',
    SYSTEM_SETTINGS: 'SystemSettings',
    RESET_CLOUD_CONNECTION: 'ResetCloudConnection',
    LOGS: 'Logs',
    ORDER: 'Order',
    SOUNDING_SPOT: 'SoundingSpot',
    BOOK_CONFIGURATION: 'BookConfiguration',
    CHECKLIST_TYPE: 'CheckListType',
    INSTALLATION_WIZARD: 'InstallationWizard',
    TLS_CERTIFICATE: 'TLSCertificate',
    RESTART: 'Restart',
};
//# sourceMappingURL=Resources.js.map